<template lang="pug">
  .form-autocomplete
    .form-group.d-flex
      label.form-radio
        input(type="radio" :value="undefined" v-model="language")
        i.form-icon
        | Todos
      label.form-radio
        input(type="radio" value="pt" v-model="language")
        i.form-icon
        | Português
      label.form-radio
        input(type="radio" value="es" v-model="language")
        i.form-icon
        | Espanhol
      label.form-radio
        input(type="radio" value="en" v-model="language")
        i.form-icon
        | Inglês
    .form-autocomplete-input.form-input
      chip(v-for="product in filteredList" :product="product" :key="product.id" @remove="onRemoveProduct")
      .has-icon-left
        i.form-icon.loading(v-if="loading")
        i.form-icon.fas.fa-search(v-else)
        input.form-input(
          type="search"
          ref="input"
          v-model="query"
          placeholder="Buscar produto"
          @focus="focused = true"
          @blur="onBlur"
          @keydown.backspace="onBackspace"
        )
    menu-autocomplete(v-if="showMenu" :list="allowedList" @select="onSelectProduct")
</template>

<script>
import Chip from './Chip'
import MenuAutocomplete from './Menu'
import products from '@/services/products'
import manyAutocompleteMixin from '../mixins/manyAutocomplete'

export default {
  components: { Chip, MenuAutocomplete },
  mixins: [manyAutocompleteMixin],
  props: { collectionType: String },
  data() {
    return { language: undefined }
  },
  computed: {
    filteredList() {
      if (!this.language) return this.value
      return this.value.filter(({ availableLanguages }) =>
        availableLanguages.includes(this.language),
      )
    },
    allowedList() {
      return this.list.filter(item => {
        const index = this.value.findIndex(selected => selected.id === item.id)
        return index === -1
      })
    },
    showMenu() {
      return this.allowedList.length > 0 && this.focused
    },
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true
        const params = { q: { title: this.query } }
        if (this.language) {
          params.q.language = this.language
        }
        const { collectionType } = this
        const productType =
          collectionType !== 'mixed' ? collectionType : undefined
        const { data } = await products.list(params, productType)
        this.list = data.rows
      } catch (e) {
        this.$toaster.error('Falha ao buscar os produtos')
      } finally {
        this.loading = false
      }
    },
    onSelectProduct(product) {
      this.$emit('input', [...this.value, product])
      this.$refs.input.focus()
      this.query = ''
      setTimeout(() => (this.focused = true), 200)
    },
    onRemoveProduct(product) {
      const value = this.value.filter(selected => selected.id !== product.id)
      this.$emit('input', value)
    },
    onBlur() {
      setTimeout(() => (this.focused = false), 200)
    },
    onBackspace() {
      if (this.query !== '') return
      let value = [...this.value]
      value.pop()
      this.$emit('input', value)
    },
  },
}
</script>
